// @ts-ignore: Unreachable code error
export const mapID = import.meta.env.VITE_MAP_ID;
